import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-footer_desktopapp_modalview_on_google_play-click';
/**
 * Click on “View on Google Play”
 */
export function trackRetailerMobileFooterDesktopappModalviewOnGooglePlayClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
